import { Outlet } from "react-router";
import { AppSidebar } from "./app-sidebar";
import { AppHeader } from "./app-header";
import { useAuth } from "@/contexts/auth-context";

export function AppShell() {
  const { isLoading, error } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg">
        <div className="text-text-3 text-sm">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex h-screen items-center justify-center bg-bg">
        <div className="text-center">
          <p className="text-danger font-medium">Unable to authenticate</p>
          <p className="text-text-3 text-sm mt-1">
            {error.message || "Please ensure you are signed in."}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen bg-bg">
      {/* Skip to content link (a11y) */}
      <a href="#main-content" className="skip-to-content">
        Skip to content
      </a>

      {/* Sidebar */}
      <AppSidebar />

      {/* Main area */}
      <div className="flex flex-1 flex-col min-w-0">
        {/* Header */}
        <AppHeader />

        {/* Page content */}
        <main
          id="main-content"
          role="main"
          className="flex-1 overflow-y-auto px-6 py-6"
        >
          <div className="mx-auto max-w-[1200px]">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
